import script from "./SocialFundAgreementUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundAgreementUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundAgreementUploadDialog.vue?vue&type=style&index=0&id=34a25c9b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a25c9b"]])

export default __exports__